module.exports = __webpack_public_path__ + "static/media/Sharp-IIS-LS027B7DH01A-11-27-13.fe3a967a.pdf";